
import { DATE_PLACES, TIME_SLOTS } from "~/constants";

export default {
    data() {
        return {
            datePlaces: DATE_PLACES,
            timeSlots: TIME_SLOTS,
        };
    },
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        sendStep(date, place) {
            this.$emit("updateStep", {
                step: 3,
                selectedDate: date,
                selectedPlace: place,
            });
            this.scrollToTop();
        },
    },
};
